<div class="feedback-layout">
  <div class="feedback-side-panel" *ngIf="feedbackStandData">
    <div class="side-container" [ngStyle]="{ background: feedbackStandData.sidebarBackgroundColor }">
      <div class="text-above-logo" [ngStyle]="{ color: feedbackStandData.textAboveLogoColor }">
        {{ feedbackStandData.descriptionText }}
      </div>
      <img [src]="feedbackStandData.logo" alt="" class="logo" (click)="refreshPage()" />
    </div>
  </div>

  <div class="feedback-main-panel">
    <section class="questionnaire-panel" *ngIf="moodSelected && currentMood" [@fadePanelTransition]>
      <question-mood [questions]="questions" [mood]="currentMood" (completed)="onQuestionnaireCompleted()"></question-mood>
    </section>

    <section class="mood-selection-panel" *ngIf="moods && !moodSelected" [@fadePanelTransition]>
      <button
        *ngFor="let mood of moods"
        class="mood-card"
        [ngClass]="setDynamicClass(mood.type)"
        [style.background-color]="getMoodColor(mood.type)"
        type="button"
        (click)="setFeedbackQuestions(mood.type)"
      >
        <span class="mood-icon">
          <img [src]="moodLogo(mood.type)" [alt]="getMoodTranslationKey(mood.type) | translate" />
        </span>
        <span class="mood-label">{{ getMoodTranslationKey(mood.type) | translate }}</span>
      </button>
    </section>
  </div>
</div>
